const pieChart = (() => {

    /**
     * init : initializing bar group chart
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param config object
     */

    const init = (config) => {
        const { width, height, color, data } = config;
        var svg = d3.select(config.id).append("svg")
      .attr("width", width)
      .attr("height", height)
      .append("g");

    svg.append("g")
			.attr("class", "slices");
    svg.append("g")
      .attr("class", "labels");
    svg.append("g")
      .attr("class", "lines");
    var radius = Math.min(width, height)/2;
    // var data = [26,25,10,30];



    var pie = d3.pie().sort(null).value(d => d);
    var arc = d3.arc().innerRadius(0).outerRadius(radius*0.6);

     var outerArc = d3.arc()
                .outerRadius(radius * 0.9)
                .innerRadius(radius * 0.9);

    svg.attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

    svg.selectAll('path')
    .data(pie(data))
    .enter()
    .append('path')
    .attr('d', arc)
    .transition()
    .duration(800)
    .attrTween('d', function(d) {
        var i = d3.interpolate(d.startAngle+0.0, d.endAngle);
        return function(t) {
            d.endAngle = i(t);
            return arc(d)
            }
        })
    .attr('fill', (d,i)=> color[i]);
    svg.append('g').classed('labels',true);
    svg.append('g').classed('lines',true);


     var polyline = svg.select('.lines')
                .selectAll('polyline')
                .data(pie(data))
              .enter().append('polyline')
                .attr('points', function(d) {

                    // see label transform function for explanations of these three lines.
                    var pos = outerArc.centroid(d);
                    pos[0] = radius * 0.92 * (midAngle(d) < Math.PI ? 1 : -1);
                    return [arc.centroid(d), outerArc.centroid(d), pos]
                });



       var label = svg.select('.labels').selectAll('text')
                .data(pie(data))
              .enter().append('text')
                .attr('dy', '.35em')
                .attr('class', "account-text")
                .text(function(d) {
                    return (config.is_doller_format ? (initScript.separateNumberByDelimiter(d.data / 1000) + "    ") : d.data);
                })
                .attr('transform', function(d) {
                    var pos = outerArc.centroid(d);
                    pos[0] = radius * 0.95 * (midAngle(d) < Math.PI ? 1 : -1);
                    return 'translate(' + pos + ')';
                })
                .style('text-anchor', function(d) {
                    return (midAngle(d)) < Math.PI ? 'start' : 'end';
                });
		function midAngle(d) { return d.startAngle + (d.endAngle - d.startAngle) / 2; }
    };
    return {
        init,
    };
})();
